export default "__VITE_ASSET__C_vco5R7__"